import Gozabeque from './Gozabeque';

export default Gozabeque;